<template>
  <!-- header start-->
  <van-nav-bar fixed title="丝路美物" left-arrow @click="$router.go(-1)"/>
  <!-- header end-->
  <!-- container start-->
  <div class="container">
    <h1 class="article-title">关于丝路美物</h1>
    <div class="article-content">
      <p>
            丝绸之路是起始于古代中国，连接亚洲、非洲和欧洲的古代陆上商业贸易路线，后来成为东方与西方之间在经济、政治、文化等诸多方面进行交流的主要道路。近年来我国倡导的“一带一路”建设，是在古代丝绸之路基础上促进亚欧非大陆及附近海洋的互联互通，建立和加强沿线各国互联互通伙伴关系。《丝路美物》商城以此为背景，致力于发现一带一路沿线国家的优质商品，将它们带回中国。
      </p>
      <p>
            <strong>客服及合作咨询：13501283770</strong>
      </p>
    </div>
    <van-image
      class="about-bg"
      :src="require('../../public/img/about-bg.png')"
    />
  </div>
  <!-- container end-->
</template>